module.exports = __webpack_public_path__ + "img/atlantic.bd310d35.jpg";